import {phoneNumberFormatter} from "@/globals/globals";

export default (step, isExport) => {

  let styles = {
    subText: '',
    headerColor: '#2c2d30'
  };

  switch(step.event){
    case 'Answer':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.subText = `${step.cidName}\n${numberFormatter(step.cidNum)}`;
      }
      break;
    case 'Busy':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description: step.extInfo}
      } else {
        styles.subText = step.extInfo;
      }
      break;
    case 'Call Reservation':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description: step.event}
      } else {
        styles.subText = step.event;
        styles.bgColorHeader = '#c485db';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Campaign Dial':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description:step.event}
      } else {
        styles.subText = step.event;
        styles.bgColorHeader = '#0F85FF';
        styles.headerColor = '#ececec'
      }
      break;
    case 'Check Condition':
      if (isExport) {
        return {event:'Time of Day', time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description:step.conditionName}
      } else {
        step.event = 'Time of Day';
        styles.subText = step.conditionName;
        styles.bgColorHeader = '#4cc3d2';
        styles.headerColor = '#ececec'
      }
      break;
    case 'Condition':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.bgColorHeader = '#35be8b';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Condition True':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.bgColorHeader = '#35be8b';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Condition False':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.bgColorHeader = '#f25a6b';
        styles.headerColor = '#ececec'
      }
      break;
    case 'Dial':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description:step.dialedExt }
      } else {
        styles.subText = numberFormatter(step.dialedExt);
        styles.bgColorHeader = '#35be8b';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Dial Multiple':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.subText = 'View All';
        styles.bgColorHeader = '#35be8b';
        styles.headerColor = '#ececec';
      }
      break;
    case 'DID':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description: numberFormatter(step.calledNum)}
      } else {
        styles.mainText = `${step.event} - ${step.didAction}`
        styles.subText = numberFormatter(step.calledNum);
        styles.bgColorHeader = '#c485db';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Dialed Number':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description: numberFormatter(step.calledNum)}
      } else {
        styles.subText = numberFormatter(step.calledNum);
      }
      break;
    case 'Feature Code':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.bgColorHeader = '#0F85FF';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Forward':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.bgColorHeader = '#35be8b';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Hangup':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.subText = `${step.cidName}\n${numberFormatter(step.cidNum)}`;
      }
      break;
    case 'Hunt List':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description:step.huntlistAction}
      } else {
        styles.subText = step.huntlistAction;
        styles.bgColorHeader = '#ff8f02';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Incoming Call':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.subText = `${step.cidName}\n${numberFormatter(step.cidNum)}`;
      }
      break;
    case 'IVR':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description: step.ivrAction}
      } else {
        styles.subText = step.ivrAction;
        styles.bgColorHeader = '#7683d8';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Offline':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description: step.extInfo}
      } else {
        styles.subText = step.extInfo;
        styles.bgColorHeader = '#35be8b';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Paging':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.bgColorHeader = '#35be8b';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Park Start':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description: numberFormatter(step.cidNum)}
      } else {
        styles.subText = numberFormatter(step.cidNum);
      }
      break;
    case 'Park End':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description: numberFormatter(step.cidNum)}
      } else {
        styles.subText = numberFormatter(step.cidNum);
      }
      break;
    case 'Parking Lot Busy':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName}
      } else {
        styles.bgColorHeader = '#ff8f02';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Playback':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description: step.playbackAction}
      } else {
        styles.subText = step.playbackAction;
        styles.bgColorHeader = '#7683d8';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Queue':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description: step.queueAction}
      } else {
        styles.subText = step.queueAction;
        styles.bgColorHeader = '#f79ca6';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Route By Phonebook':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description:step.phonebookAction}
      } else {
        styles.subText = step.phonebookAction;
        styles.bgColorHeader = '#7683d8';
        styles.headerColor = '#ececec';
      }
      break;
    case 'Voicemail':
      if (isExport) {
        return {event:step.event, time:step.timeCST, callerNumber:numberFormatter(step.cidNum), callerName:step.cidName, description:step.voicemailAction}
      } else {
        styles.subText = step.voicemailAction;
        styles.bgColorHeader = '#7683d8';
        styles.headerColor = '#ececec';
      }
      break;
    default:
      break;
  }

  return styles;

}

function numberFormatter (num) {

  if(Array.isArray(num)){
    if(!num.length){
      return '';
    }

    if(num.length > 1){
      return num;
    }

    return phoneNumberFormatter(num[0]);
  }

  return phoneNumberFormatter(num);
}

